const _excluded = ["onLoadMore", "shimmerSize", "buttonDisabled", "bottomFilters", "shimmerDataId", "wrapperStyles", "listTableWrapperStyles"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { ListTable } from '../List/ListTable';
import { Shimmer, Stack } from 'office-ui-fabric-react';
import { DefaultButton } from '../Button/Default';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ListWithLoadMoreShimmerLoader = _ref => {
  let {
    shimmerLines,
    shimmerDataId
  } = _ref;
  return /*#__PURE__*/_jsx(Stack, {
    styles: {
      root: {
        justifyContent: 'space-evenly',
        height: '100%',
        width: '100%'
      }
    },
    "data-id": shimmerDataId,
    children: new Array(shimmerLines || 10).fill('').map((_item, index) => /*#__PURE__*/_jsx(Shimmer, {
      styles: {
        shimmerWrapper: {
          margin: '18px 0',
          height: 7
        }
      }
    }, index))
  });
};
export function ListWithLoadMore(props) {
  const {
      onLoadMore,
      shimmerSize,
      buttonDisabled,
      bottomFilters,
      shimmerDataId,
      wrapperStyles,
      listTableWrapperStyles
    } = props,
    listProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsxs(Stack, {
    styles: wrapperStyles,
    children: [/*#__PURE__*/_jsx(ListTable, _objectSpread(_objectSpread({}, listProps), {}, {
      disableListShimmers: true,
      wrapperStyles: listTableWrapperStyles
    })), listProps.isLoading && /*#__PURE__*/_jsx(ListWithLoadMoreShimmerLoader, {
      shimmerLines: shimmerSize,
      shimmerDataId: shimmerDataId
    }), /*#__PURE__*/_jsxs(Stack, {
      styles: {
        root: {
          justifyContent: 'center',
          paddingTop: 20,
          position: 'relative'
        }
      },
      horizontal: true,
      children: [/*#__PURE__*/_jsx(DefaultButton, {
        styles: {
          root: {
            width: 'auto'
          }
        },
        onClick: onLoadMore,
        disabled: buttonDisabled || listProps.isLoading,
        "data-id": "load-more-button",
        children: "Load More"
      }), bottomFilters]
    })]
  });
}